import React, { ReactNode } from 'react';
import classNames from 'classnames/bind';
import styles from './ChartContainer.module.scss';

const cx = classNames.bind(styles);

type ChartContainerProps = {
  height?: number;
  children: ReactNode;
};

const ChartContainer: React.FC<ChartContainerProps> = ({ height = '300', children }) => {
  const chartContainerStyle = {
    '--chart-height': `${height}px`,
  } as React.CSSProperties;
  return (
    <div className={cx('body')} style={chartContainerStyle} data-testid="chart-container">
      {children}
    </div>
  );
};

export default ChartContainer;
